import React from 'react'
import './Textarea.css'

export default function ReactTextarea(props) {
	return (
		<textarea
			className="textarea"
			onChange={props.onChange}
			placeholder={props.placeholder}
			style={{height: props.height, margin: props.margin}}
			value={props?.value}
		></textarea>
	)
}